import { Component, Emit, Prop, Vue } from "vue-property-decorator";
import { GraphApiResult } from '@/models/graphApiResult';
import { Tasks } from '@/models/tasks';
import { ApiResult } from '@/enums';
import { PlannerUtils } from '@/utils/plannerUtils';
import { AppConfig } from '@/app-config';
import { DateUtils } from '@/utils/dateUtils';

@Component
export default class ChannelItem extends Vue {
	@Prop() public channelId!: string;
	@Prop() public channelName!: string;
	@Prop() public channelStatusString!: string;
	@Prop() public planId!: string;
	private channelDateString: string = '';

	@Emit()
	public click(channelId: string) { }

	public async created(): Promise<void> {
		this.channelDateString = await this.getLectureDateString(this.planId);
	}

	public onClick(e: Event): void {
		if (e.currentTarget === null) {
			return;
		}
		this.click(this.channelId);
	}

	// TODO 外から設定できるようにしたい
	private async getLectureDateString(planId: string): Promise<string> {
		let dateString: string = '';
		const accessToken: string = Vue.$accessTokenInfo.token;
		const tasks = await this.getTasks(accessToken, this.planId);
		if (tasks !== null) {
			const lectureTask = tasks.getByTitle(AppConfig.ADMIN_TASK_NAME_GIVE_LECTURE);
			if ((lectureTask !== null) && (lectureTask.dueDateTime !== null)) {
				const date = DateUtils.GetStringWithSlash(lectureTask.dueDateTime);
				dateString = `講義日：${date}`;
			}
		}
		return dateString;
	}

	private async getTasks(accessToken: string, planId: string): Promise<Tasks | null> {
		const tasksResult: GraphApiResult<Tasks> = await PlannerUtils.GetTasks(accessToken, planId);
		if ((tasksResult.result !== ApiResult.Success) || (tasksResult.value === null)) {
			alert('タスクの取得に失敗しました。');
			return null;
		}
		const tasks: Tasks = tasksResult.value;
		return tasks;
	}
}
